<template>
  <div>
    <vs-prompt
      title="Review order"
      @cancel="val = ''"
      @accept="accept"
      :active.sync="prompt"
      accept-text="Place order"
      :buttons-hidden="!isEditable"
      class="activate-order-popup"
    >
      <div class="data-list-container data-list-list-view" v-if="order">
        <div class="max-w-md ml-4">
          <vs-row>
            <vs-col vs-w="4">
              <b>Venue: </b>
            </vs-col>
            <vs-col vs-w="8">
              <code>
                {{ venue.name }}
              </code>
            </vs-col>
          </vs-row>
          <vs-row class="mt-2">
            <vs-col vs-w="4">
              <b>Order total: </b>
            </vs-col>
            <vs-col vs-w="8">
              <b>
                {{ totalOrderPrice | numberFormatDK }}
              </b>
            </vs-col>
          </vs-row>
          <vs-row class="mt-2">
            <vs-col vs-w="4">
              <b>Status: </b>
            </vs-col>
            <vs-col vs-w="8">
              <vs-chip :color="stateMapping[order.status].color">
                {{ order.status }}
              </vs-chip>
            </vs-col>
          </vs-row>
          <vs-row class="mt-2">
            <vs-col vs-w="4">
              <b>Created by: </b>
            </vs-col>
            <vs-col vs-w="8">
              {{ order.createdBy.username }} at
              {{ order.createdAt | formatDate }}
            </vs-col>
          </vs-row>
          <vs-row class="mt-2" v-if="order.updatedBy">
            <vs-col vs-w="4">
              <b>Last update by: </b>
            </vs-col>
            <vs-col vs-w="8">
              {{ order.updatedBy.username }} at
              {{ order.updatedAt | formatDate }}
            </vs-col>
          </vs-row>
          <vs-row class="mt-2" v-if="order.activatedBy">
            <vs-col vs-w="4">
              <b>Order placed by: </b>
            </vs-col>
            <vs-col vs-w="8">
              {{ order.activatedBy.username }} at
              {{ order.activatedAt | formatDate }}
            </vs-col>
          </vs-row>
          <vs-row class="mt-2" v-if="order.cancelledBy">
            <vs-col vs-w="4">
              <b>Order cancelled by: </b>
            </vs-col>
            <vs-col vs-w="8">
              {{ order.cancelledBy.username }} at
              {{ order.cancelledAt | formatDate }}
            </vs-col>
          </vs-row>
        </div>

        <vs-table
          ref="table"
          class="mt-8"
          pagination
          maxItems="12"
          :data="order.orderLines"
          noDataText="No data"
        >
          <template slot="header">
            <h3>Order lines</h3>
          </template>
          <template slot="thead">
            <vs-th sort-key="number">Number</vs-th>
            <vs-th sort-key="stockProductName">Name</vs-th>
            <vs-th sort-key="venueStockAmount">Current stock amount</vs-th>
            <vs-th>New stock amount vs desired</vs-th>
            <vs-th sort-key="unitPrice">Unit price</vs-th>
            <vs-th sort-key="itemQuantity">Unit amount</vs-th>
            <vs-th sort-key="caseSize">Case size</vs-th>
            <vs-th sort-key="orderCases">Cases to order</vs-th>
            <vs-th sort-key="linePrice">Line price</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                <vs-td>
                  <div
                    class="
                      product-name
                      font-medium
                      truncate
                      flex flex-row
                      items-center
                    "
                  >
                    <img width="40" :src="ProductIcon" />
                    <p class="ml-4">{{ tr.stockProductId.id }}</p>
                  </div>
                </vs-td>
                <vs-td :data="tr.stockProductName">
                  <div v-if="tr.stockProductName">
                    {{ tr.stockProductName }}
                  </div>
                  <div v-else>
                    <vs-chip> No name </vs-chip>
                  </div>
                </vs-td>
                <vs-td :data="tr.venueStockAmount">
                  <div>
                    {{ tr.venueStockAmount }}
                  </div>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                  <vs-chip
                    :color="
                      tr.venueStockAmount +
                        tr.orderQuantity -
                        tr.venueDesiredStockAmount <
                      0
                        ? 'danger'
                        : 'green'
                    "
                  >
                    {{ tr.venueStockAmount + tr.orderQuantity }}
                  </vs-chip>
                  <span class="ml-1">/</span>
                  {{ tr.venueDesiredStockAmount }}
                </vs-td>
                <vs-td :data="tr.unitPrice">
                  {{ tr.unitPrice }}
                </vs-td>
                <vs-td :data="tr.itemQuantity">
                  <div v-if="tr.itemQuantity">
                    {{ tr.itemQuantity.amount }} {{ tr.itemQuantity.unit }}
                  </div>
                </vs-td>
                <vs-td :data="tr.caseSize">
                  {{ tr.caseSize }}
                </vs-td>
                <vs-td :data="tr.orderCases">
                  <vx-tooltip
                    :text="`Ordering ${tr.orderCases} cases, each containing ${tr.caseSize} units, for a total of ${tr.orderQuantity} units`"
                  >
                    <vs-chip>
                      {{ tr.orderCases }}
                    </vs-chip>
                    <small class="ml-1"> ({{ tr.orderQuantity }}) </small>
                  </vx-tooltip>
                </vs-td>
                <vs-td :data="tr.linePrice">
                  <vx-tooltip
                    :text="`Calculated as: ${tr.caseSize} * ${tr.unitPrice} * ${tr.orderCases} = ${tr.linePrice}`"
                  >
                    <b>{{ tr.linePrice | numberFormatDK }}</b>
                  </vx-tooltip>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ProductIcon from "@/assets/images/product-icon.png";
export default {
  data() {
    return {
      moment,
      ProductIcon,

      prompt: false,
      order: null,
    };
  },
  computed: {
    ...mapGetters({
      venue: "venues/activeVenue",
      stateMapping: "orders/stateMapping",
    }),
    isEditable() {
      return this.order && this.order.status === "Draft";
    },
    totalOrderPrice() {
      return this.order.orderLines.reduce((acc, line) => {
        return acc + line.linePrice;
      }, 0);
    },
  },
  methods: {
    async show(order) {
      this.order = order;
      console.log("ORDER preview", order);
      this.prompt = true;
    },
    async accept() {
      try {
        await this.$store.dispatch("orders/activateOrder", this.order.id);
        await this.$store.dispatch("orders/getOrders", this.order.venueId.id);
        this.$vs.notify({
          title: "Order successful",
          text: "Your order has been placed.",
        });

        this.$emit("onOrderPlaced");
      } catch (err) {
        this.$vs.notify({
          title: "Error",
          text: `Failed to place order: ${err}`,
        });
      }
    },
  },
};
</script>

<style lang="scss">
.activate-order-popup {
  z-index: 52011;

  .vs-dialog {
    max-width: 1200px;

    .vs-dialog-text {
      background-color: #f8f8f8;
    }

    .header-table.vs-table--header {
      margin-left: 0 !important;
    }
  }
}
</style>
